export const THEME_NAMES = {
  neutral: "neutral",
  demo: "demo",
  nemuru: "nemuru",
  testuru: "testuru",
  real_turf: "real_turf",
  caixabank: "caixabank",
  citiservi: "citiservi",
  cochesnet: "cochesnet",
  proinso: "proinso",
  BBVATheme: "BBVATheme",
  quix: "quix",
  astara: "astara",
  carrefour: "carrefour",
  upf: "upf",
  peralba: "peralba",
  telefonica: "telefonica",
  esade: "esade",
  sunhero: "sunhero",
  iberia: "iberia",
  vaillant: "vaillant",
  saunier_duval: "saunier_duval",
  hofmann: "hofmann",
  ventajon: "ventajon",
  the_power: "the_power",
  santander: "satander",
  ktuin: "ktuin",
  farma_leaders_talento: "farma_leaders_talento",
  flash_data_academy: "flash_data_academy",
  pontio: "pontio",
  inventario_pro: "inventario_pro",
  davofrio: "davofrio",
  smartfy: "smartfy",
  mb_selector: "mb_selector",
  quadis: "quadis",
  momentum: "momentum",
  lisa_institute: "lisa_institute",
  formacion_universitaria: "formacion_universitaria",
  dcore: "dcore",
};
